module.exports = __webpack_public_path__ + "fr.svg?1827a83fd94f3a9538c85efed7386856";